import { render, staticRenderFns } from "./PasswordChange.vue?vue&type=template&id=2706992b&scoped=true&"
import script from "./PasswordChange.vue?vue&type=script&lang=ts&"
export * from "./PasswordChange.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordChange.vue?vue&type=style&index=0&id=2706992b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2706992b",
  null
  
)

export default component.exports